"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsTimestamp = void 0;
var class_validator_1 = require("class-validator");
function IsTimestamp(options) {
    return function (obj, propertyName) {
        return (0, class_validator_1.registerDecorator)({
            name: 'isTimestamp',
            target: obj.constructor,
            propertyName: propertyName,
            constraints: [],
            options: __assign({ message: "".concat(propertyName, " is not a valid timestamp") }, options),
            validator: {
                validate: function (value, _args) {
                    if (!isNaN(value)) {
                        try {
                            new Date(value);
                            return true;
                        }
                        catch (_a) { }
                    }
                    return false;
                },
            },
        });
    };
}
exports.IsTimestamp = IsTimestamp;
//# sourceMappingURL=is-timestamp.js.map